import React from 'react'
import env from './../../../environments/environment'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react-lite'
import {
  MDBFileInput,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
} from 'mdbreact'
import UserProfileService from './../../../shared/services/UserProfile.service'
import EopolicyStore from './Eopolicy.store'
import AgentProfileStore from './../AgentProfileIntake/AgentProfile.store'
import exErrorOmission from './assets/imgs/img.errors-omissions.png'

const downloadPdf = (url) => {
  if (url)
    window.open(
      `https://firebasestorage.googleapis.com/v0/b/${
        env.integrations.firebase.config.storageBucket
      }/o/${encodeURIComponent(decodeURIComponent(url))}?alt=media`
    )
}

const EandOPolicyUploader = (props) => {
  const {
    Policy,
    getGroupUrl,
    showModal,
    deletePolicyPdf,
    isDeleting,
    onSelectFile,
    getIsValid,
    isSaving,
    isUploading,
  } = EopolicyStore
  if (!Policy) return <></>

  const renderFileOutput = () => {
    return (
      <div className="img-wrapper">
        {Policy?.get('eopolicy_pdf') &&
        `${Policy.get('eopolicy_pdf')}`.trim().length > 0 ? (
          <>
            <div
              onClick={() => (EopolicyStore.showModal = true)}
              className="delete-btn"
            >
              <MDBIcon icon="trash" className="remove" />
            </div>
            <div className="img">
              <img src={exErrorOmission} alt="Agent's E&O Policy" />
              <small>Uploaded</small>
            </div>
            <div
              onClick={() =>
                downloadPdf(`${Policy.get('eopolicy_pdf')}`.trim())
              }
              className="download-btn"
            >
              <MDBIcon icon="download" />
              &nbsp;Download Your Personal E&O Policy
            </div>
          </>
        ) : (
          <>
            <MDBFileInput
              disabled={!Policy?.id() || isSaving || isUploading}
              name="eopolicy_pdf"
              accept="image/*"
              getValue={(value) => onSelectFile(value[0])}
              btnTitle={
                isUploading
                  ? 'Uploading ...'
                  : 'Upload your Personal E&O Certificate'
              }
              textFieldTitle={'Your Policy File'}
            />
          </>
        )}
      </div>
    )
  }

  const renderGroupPolicy = () => {
    if (UserProfileService.isA(['affiliate-group', 'associate-group']))
      return <></>

    if (getGroupUrl())
      return (
        <div className="group-policy-wrapper">
          <a
            className="btn view-group-policy-btn"
            href={getGroupUrl()}
            target="_BLANK"
            rel="noopener noreferrer"
          >
            View Group E&O Certificate
          </a>
        </div>
      )
  }

  return (
    <div
      className={[
        'input-wrapper upload-input-wrapper',
        !Policy?.get('eopolicy_pdf') ? 'active-input' : '',
        !Policy?.id() ? 'disabled-input' : '',
        Policy?.id() && !Policy?.get('eopolicy_pdf') ? 'invalid-input' : '',
      ].join(' ')}
    >
      {renderFileOutput()}
      {renderGroupPolicy()}
      <MDBModal
        isOpen={showModal}
        toggle={() => (EopolicyStore.showModal = false)}
        className="confirm-delete-modal"
      >
        <MDBModalHeader toggle={() => (EopolicyStore.showModal = false)}>
          Confirm Delete?
        </MDBModalHeader>
        <MDBModalBody>
          <h5 className="text-center">
            <strong>
              Are you sure you want to delete the {Policy?.get('carrier_name')}{' '}
              E&O Policy Document?
            </strong>
          </h5>
          <br />
          {Policy?.get('eopolicy_pdf') && (
            <MDBBtn
              block
              disabled={isDeleting}
              onClick={() => {
                deletePolicyPdf().then(
                  (msg) =>
                    toast.success('The E&O policy document has been deleted.', {
                      position: toast.POSITION.TOP_RIGHT,
                    }),
                  (err) =>
                    toast.error(`${err}`, {
                      position: toast.POSITION.TOP_RIGHT,
                    })
                )
                AgentProfileStore.setValidity('eopolicy', getIsValid())
              }}
            >
              Yes, Delete E&O Policy Document
            </MDBBtn>
          )}
          <MDBBtn
            block
            disabled={isDeleting}
            onClick={() => (EopolicyStore.showModal = false)}
          >
            Cancel
          </MDBBtn>
        </MDBModalBody>
      </MDBModal>
    </div>
  )
}

export default observer(EandOPolicyUploader)
